import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { B300, B50, N20A, N30, N500 } from '@atlaskit/theme/colors';
var buttonStyle = {
  outline: 'none',
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-200, 12px)"),
  display: 'inline-flex',
  fontWeight: "var(--ds-font-weight-regular, 400)",
  border: 'none',
  borderRadius: '14px',
  fontSize: '14px',
  lineHeight: '20px',
  height: '28px',
  cursor: 'pointer',
  verticalAlign: 'top',
  marginLeft: "var(--ds-space-100, 8px)"
};
export var selectedButtonStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
  backgroundColor: "var(--ds-background-selected, ".concat(B50, ")"),
  color: "var(--ds-text-selected, ".concat(B300, ")"),
  '&:hover': {
    backgroundColor: "var(--ds-background-selected, ".concat(B50, ")")
  }
});
export var unSelectedButtonStyle = _objectSpread(_objectSpread({}, buttonStyle), {}, {
  backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20A, ")"),
  color: "var(--ds-text, ".concat(N500, ")"),
  '&:hover': {
    backgroundColor: "var(--ds-background-accent-gray-subtlest-hovered, ".concat(N30, ")")
  }
});